import { parseDenkerModeCommand } from "@/lib/denker-command-normalizer";
import { isTauri } from "@/lib/is-tauri";
import { useDesktopMode } from "@/stores/desktop-mode-store";

export function tryRunDenkerModeCommand(text: string): boolean {
  const target = parseDenkerModeCommand(text);
  if (!target || !isTauri()) return false;
  const mode = useDesktopMode.getState();
  if (target === "compact") {
    mode.closeWorkspace();
  } else if (target === "workspace") {
    mode.openWorkspace();
  } else {
    mode.openDenkMode();
  }
  return true;
}
